import PlIcon from "../pl_icon";
import {p1, p2, p4, p8, p16, p32} from "../../pl_commons";
import React, {useState} from "react";
import {send_ac_cmd} from "../../../../etc/cmd";
import {connect} from "react-redux";


const TtPosIcon = ({item, parentitem, tttkitems}) => {

    let bmstate = item.fbstat === true || item.fbstat === "true"
    let bmlcid = item.bmlc

    const [area, setArea] = useState(false)

    function doClick(val) {
        const cc = {
            id: parentitem.id,
            wanted: item.asp,
        }
        send_ac_cmd(cc)
    }

    let ang = item.ang - 30
    if (ang < 0) {
        ang = ang + 360
    }

    var s1 = Math.sin((90 + ang) / 180 * Math.PI)
    var c1 = Math.cos((90 + ang) / 180 * Math.PI)

    const center = (p1 * 5)
    const m0 = p2 + (p1 * 3)
    const m1 = p2 + (p1 * 3) + p2
    const m2 = m0 + p1;

    const ds1 = -2 * p1
    const ds2 = 2 * p1

    const dsx1 = -3 * p1
    const dsx2 = -m0 + 10

    let busstate = parseInt(parentitem.accessorystate)
    const buswait = parseInt(parentitem.accessorywait)

    var svgitems = []
    var hoveritems = []


    let fillcolor = "#a8b6be"


    let oppo = ang + 180
    if (oppo < 0) {
        oppo += 360
    } else if (oppo > 360) {
        oppo -= 360
    }


    let csz = p8
    if (parseInt(busstate) === parseInt(item.asp)) {
        if (!buswait) {
            fillcolor = "#42c420"
        } else {
            fillcolor = "#ddee44"
        }
    }



    let transformt = `rotate(${ang || 0},${center},${center})`;
    let transformoppo = `rotate(${oppo},${center},${center})`;

    //clickarea
    svgitems.push(<circle key={"c1"} cx={center - m0} cy={center} r={p4 + p16} stroke={"#FFFFFF00"} strokeWidth="1"
                          fill={"#FFFFFF00"} onClick={doClick}
                          onMouseEnter={() => setArea(true)} onMouseLeave={() => setArea(false)}
                          transform={transformt}/>)


    if (area) {
        fillcolor = "#dc5e10"
        //hoveritems.push(<line x1={center - s1*dsx1} y1={center + c1*dsx1} x2={center - s1*dsx2} y2={center + c1*dsx2} strokeWidth={"3"} stroke={fillcolor}/>)
        let angx = ang + 180
        if (angx > 360) {
            angx -= 360
        }

        let transformtx = `rotate(${angx},${center},${center})`;

        // opposite
        hoveritems.push(<circle key={"c12"} cx={center - (p4 * 15 + p32)} cy={center} r={p8} stroke={"#464646"}
                                strokeWidth="1" fill={fillcolor} transform={transformtx}/>)
    }


    const mx = ang % 10 === 0 ? m0 : m1
    svgitems.push(<circle key={"c13x"} cx={center - mx} cy={center} r={csz} stroke={"#464646"} strokeWidth="1"
                          fill={fillcolor}
                          onClick={doClick}
                          onMouseEnter={() => setArea(true)} onMouseLeave={() => setArea(false)}
                          transform={transformt}/>)

    /*svgitems.push(<circle key={"c13y"} cx={center - mx} cy={center} r={csz} stroke={"#464646"} strokeWidth="1"
                          fill={fillcolor}
                          transform={transformoppo}/>)*/


    if (item.track) {
        if (item.bmlc && item.bmlc !== "0") {

            let s0 = 1
            let a0 = ang + 180;
            if (a0 < 270) {
                a0 -= 180;
                s0 = -1
            }

            let transformtxt = `translate(${center}, ${center} ) rotate(${a0}) translate(${s0 * p4 * 17}, ${0} )`;
            svgitems.push(<text key={"t13"} x={0} y={0} fontSize={p4 + p16}
                                dominantBaseline={'central'} textAnchor={'middle'}
                                transform={transformtxt}>{bmlcid}</text>)
        } else {
            svgitems.push(<line key={"l14"} x1={center - 18 * p4} y1={center} x2={center - 15 * p4} y2={center}
                                transform={transformt} strokeWidth={2} stroke={bmstate ? "#ff0000" : "#464646"}/>)
        }

        svgitems.push(<line key={"l15"} x1={center - 13 * p4} y1={center} x2={center - 4 * p2} y2={center}
                            transform={transformt} strokeWidth={p8} stroke={"#464646"}/>)

        svgitems.push(<line key={"l16"} x1={center - 12 * p4} y1={center} x2={center - 9 * p4} y2={center}
                            transform={transformt} strokeWidth={p16} stroke={bmstate ? "#ff0000" : "#464646"}/>)
    }

    return (
        <>
            <svg>
                {svgitems}
                {hoveritems}
            </svg>
        </>
    )
}


export default TtPosIcon


